import {ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input} from "@angular/core";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "fui-icon",
    templateUrl: "./icon.component.html",
    styleUrls: ["./icon.component.scss"]
})
export class FUIIconComponent {
    @HostBinding("class.clickable") @Input() clickable: boolean = false;

    private _icon: string;
    private _height: number;
    private _width: number;
    private _color: string;

    constructor(private changeDetectorRef: ChangeDetectorRef) {
    }

    /**
     *
     * @returns {string}
     */
    get icon(): string {
        return this._icon;
    }

    /**
     *
     * @param {string} icon
     */
    @Input()
    set icon(icon: string) {
        if (this._icon != icon) {
            this._icon = icon;
            this.changeDetectorRef.markForCheck();
        }
    }

    /**
     *
     * @returns {number}
     */
    get height(): number {
        return this._height;
    }

    /**
     *
     * @param {number} height
     */
    @Input()
    set height(height: number) {
        if (this._height != height) {
            this._height = height;
            this.changeDetectorRef.markForCheck();
        }
    }

    /**
     *
     * @returns {number}
     */
    get width(): number {
        return this._width;
    }

    /**
     *
     * @param {number} width
     */
    @Input()
    set width(width: number) {
        if (this._width != width) {
            this._width = width;
            this.changeDetectorRef.markForCheck();
        }
    }

    /**
     *
     * @returns {string}
     */
    get color(): string {
        return this._color;
    }

    /**
     *
     * @param {string} color
     */
    @Input()
    set color(color: string) {
        if (this._color != color) {
            this._color = color;
            this.changeDetectorRef.markForCheck();
        }
    }
}
